import ChangePassword from "../changePassword/ChangePassword";
import { LoginWrapper } from "../login/LoginWrapper";

const ExpiredPassword = () => {
  return (
    <LoginWrapper>
      <ChangePassword isExpiredPasswordChange />
    </LoginWrapper>
  );
};

export default ExpiredPassword;
